import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {Link, withRouter} from 'react-router-dom'

/* Utils */
import {isExternalUrl} from '../../common/url/urlUtils'
import {matchUrlInRouteConfigs} from '../../core/route/routeUtils'

const HbLink = ({
  className,
  children,
  to,
  isDisabled,
  onClick,
  target,
  rel,
  title,
  customAnchorProps,
  location,
  forceRedirect
}) => {
  const containerClassName = classNames(className)

  const shouldRenderAnchor = () => {
    let result;

    if (!process.env.BROWSER) {
      result = true;
    } else if (to && !isDisabled) {
      if (typeof to === 'object') {
        result = false;
      } else {
        const isExternal = isExternalUrl(to);

        if (isExternal) {
          result = true;
        } else {
          result = !matchUrlInRouteConfigs(to);
        }
      }
    } else {
      result = true;
    }

    return result
  }

  return shouldRenderAnchor() ? (
    <a
      className={containerClassName}
      href={isDisabled ? '' : to}
      onClick={onClick}
      {...customAnchorProps}
      target={target}
      title={title}
      rel={rel}>
      {children}
    </a>
  ) : forceRedirect ? (
    <a
      className={containerClassName}
      href={isDisabled ? '' : to}
      onClick={onClick}
      {...customAnchorProps}
      target={target}
      title={title}
      rel={rel}>
      {children}
    </a>
  ) : (
    <Link
      className={containerClassName}
      to={isDisabled ? '' : to}
      onClick={onClick}
      {...customAnchorProps}
      target={target}
      replace={to === location.pathname + location.search}
      title={title}
      rel={rel}>
      {children}
    </Link>
  )
}

HbLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isDisabled: PropTypes.bool.isRequired,
  target: PropTypes.string,
  title: PropTypes.string,
  rel: PropTypes.string,
  customAnchorProps: PropTypes.object,
  onClick: PropTypes.func,
  forceRedirect: PropTypes.bool
}

HbLink.defaultProps = {
  isDisabled: false,
  target: ''
}

export default withRouter(HbLink)
